import React from 'react';
import './style.scss';

export default function InputContainer(props) {
  const inputFirstName = {
    className: `prevent input-field ${props.firstName.inputClass || ''}`,
    type: props.firstName.type || 'text',
    value: props.firstName.value,
    onChange: props.firstName.handleChange,
    disabled: props.firstName.disabled,
    name: props.firstName.name,
  };
  const inputLastName = {
    className: `prevent input-field ${props.lastName.inputClass || ''}`,
    type: props.lastName.type || 'text',
    value: props.lastName.value,
    onChange: props.lastName.handleChange,
    disabled: props.lastName.disabled,
    name: props.lastName.name,
  };

  if (props.firstName.validate) {
    inputFirstName.onBlur = (event) => {
      props.lastName.validate(event.target.value);
    };
  }
  if (props.lastName.validate) {
    inputLastName.onBlur = (event) => {
      props.lastName.validate(event.target.value);
    };
  }

  return (
    <div
      className={`${
        props.validationError ? 'input-container invalid' : 'input-container'
      } ${props.className || ''} box-input-container`}
    >
      <div className="d-flex align-items-center box">
        <div className="h-100 d-flex justify-content-center align-items-center">
          <div className={`title ${props.placeholder ? '' : 'd-none'}`}>
            {props.placeholder}
          </div>
        </div>
        <div className="input-container">
          <input {...inputFirstName} />
        </div>
        <div className="input-container flex-grow-1">
          <input {...inputLastName} />
        </div>
      </div>

      {props.validationError && (
        <p className="input-validation-error mt-1 text-left">
          {props.validationError}
        </p>
      )}
    </div>
  );
}
